import * as angular from 'angular';
import { Transition } from '@uirouter/angularjs';

export const appState = {
	name: 'app',
	component: 'mxApp',
	abstract: true,
	resolve: {
		showLayout: function () {
			angular.element('body').removeClass('hideBody');
			angular.element('.mx-index-loading').removeClass('mx-index-loading');
		},
	},
};

export const authAppState = {
	parent: appState.name,
	name: 'authApp',
	abstract: true,
};

export const defaultAppState = {
	name: 'defaultAppState',
	parent: appState.name,
	redirectTo: function (transition: Transition) {
		return transition.router.stateService.target('shell');
	},
};
